import PastNotes from "modules/PastNotes/View";

import { ENotesEntity, EPipelineSlug } from "@type/api/management/types";

function PersonalCustomerSuccessPastNotes() {
  return (
    <PastNotes
      entityType={ENotesEntity.STAFF}
      pipelineSlug={EPipelineSlug.CUSTOMER_SUCCESS}
    />
  );
}

export default PersonalCustomerSuccessPastNotes;
